(function IIFE() {
    'use strict';

    /////////////////////////////

    function RoleFactory($resource, Config) {
        'ngInject';

        return $resource(Config.HAUSSMANN_HOST + '/_ah/api/lumsites/v1/role/:methodKey', {}, {
            'check': {
                isArray: false,
                method: 'POST',
                params: {
                    methodKey: 'check',
                },
                url: Config.HAUSSMANN_HOST + '/_ah/api/lumsites/v1/role/:methodKey'
            },

            'delete': {
                isArray: false,
                method: 'DELETE',
                params: {
                    methodKey: 'delete',
                },
            },

            'get': {
                isArray: false,
                method: 'GET',
                params: {
                    methodKey: 'get',
                },
                url: Config.HAUSSMANN_HOST + '/_ah/api/lumsites/v1/role/:methodKey'
            },

            'list': {
                isArray: false,
                method: 'GET',
                params: {
                    methodKey: 'list',
                },
                url: Config.HAUSSMANN_HOST + '/_ah/api/lumsites/v1/role/:methodKey'
            },

            'save': {
                isArray: false,
                method: 'POST',
                params: {
                    methodKey: 'save',
                },
            },
        });
    }

    /////////////////////////////

    angular.module('Factories').factory('RoleFactory', RoleFactory);
})();
